import styled from 'styled-components';

interface IContainerProps {
  padding?: string;
  backgroudColor?: string;
}

export const Container = styled.div<IContainerProps>`
    background-color: ${props => props.backgroudColor || '#efefef'};
    padding: ${props => props.padding || '5px'};
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
`

export const LeftContainer = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-start;

    & ul {
        margin-bottom: 0px!important;
        align-items: center;
        align-content: center;
        justify-content: flex-start;
    }
`

export const RightContainer = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: flex-end;
`

export const Description = styled.span`
    color: #74777A;

    @media screen and (max-width: 700px) {
        font-size: 0.8em;
    }
`

export const DescriptionCentered = styled.div`
    text-align: center;
    color: #74777A;
    flex: 1;
`

export const TotalAmount = styled.span`
    color: #74777A;
    margin-left: 10px;

    @media screen and (max-width: 700px) {
        font-size: 0.8em;
        margin-left: 5px;
    }
`